import { useTranslations } from '@vocab/react';
import { Text, TooltipRenderer, Box } from 'braid-design-system';

import { IconSeekPassSupertick } from 'src/components/common/Certsy/Icons/IconSeekPassSupertick/IconSeekPassSupertick';

import translations from './.vocab';

export const CertsyIdentityVerified = ({
  idSuffix,
  certsyVerifiedFullName,
}: {
  idSuffix: string;
  certsyVerifiedFullName: string;
}) => {
  const { t } = useTranslations(translations);

  return (
    <TooltipRenderer
      id={`certsy-identity-verified-tooltip-${idSuffix}`}
      tooltip={
        <Text>
          {t(
            'This person has verified their identity as certsyVerifiedFullName.',
            {
              certsyVerifiedFullName,
            },
          )}
        </Text>
      }
    >
      {({ triggerProps }) => (
        // FIXME: NVL - the display need to be `inline` in ProfileHeader to avoid weird wrapping issues and `flex` for JobApplicationCard to align it center
        // might be better to have it as a display prop
        <Box {...triggerProps} display="flex" alignItems="center">
          <IconSeekPassSupertick />
        </Box>
      )}
    </TooltipRenderer>
  );
};
